import { render, staticRenderFns } from "./OrderTransitionAction.vue?vue&type=template&id=dda18af4&"
import script from "./OrderTransitionAction.vue?vue&type=script&lang=ts&"
export * from "./OrderTransitionAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports